import React from 'react';
import PropTypes from 'prop-types';

const withInputValueOnChangeHOCGenerator = (Component) => {
  function WithInputValueOnChangeHOC(props) {
    const { resetValidationMessage, setInputValue, validateOnChange } = props;
    const inputOnChange = (inputValue) => {
      resetValidationMessage();
      setInputValue(inputValue);
      validateOnChange();
    };
    return <Component {...props} inputOnChange={inputOnChange} />;
  }

  WithInputValueOnChangeHOC.propTypes = {
    resetValidationMessage: PropTypes.func,
    setInputValue: PropTypes.func,
    validateOnChange: PropTypes.func,
  };

  return WithInputValueOnChangeHOC;
};

const withInputValueOnChange = () => (Component) => withInputValueOnChangeHOCGenerator(Component);

export default withInputValueOnChange;
